import { TransactionTaxDto } from '../dtos';

export class TransactionTaxBuilder {
  private transactionTax: TransactionTaxDto;

  constructor() {
    this.transactionTax = new TransactionTaxDto();
  }

  public setTaxRate(taxRate: number): TransactionTaxBuilder {
    this.transactionTax.taxRate = taxRate;
    return this;
  }

  public setPercent(percent: number): TransactionTaxBuilder {
    this.transactionTax.percent = percent;
    return this;
  }

  public setAmount(amount: number): TransactionTaxBuilder {
    this.transactionTax.amount = amount;
    return this;
  }

  public setTotalTaxable(totalTaxable: number): TransactionTaxBuilder {
    this.transactionTax.totalTaxable = totalTaxable;
    return this;
  }

  public build(): TransactionTaxDto {
    return this.transactionTax;
  }
}
